import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import Settings from "./Settings";

// const Route = React.lazy(() => import("./Settings"));

export const SettingsRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <Settings />
    </Suspense>
  );
};
